import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface DatenverwaltungEnergiesteuerProps {
    dummy?: any;
}

export interface DatenverwaltungEnergiesteuerState {
    dummy?: any;
}

export class DatenverwaltungEnergiesteuer extends
    React.Component<DatenverwaltungEnergiesteuerProps, DatenverwaltungEnergiesteuerState> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_PARAMETER_ENERGIESTEUER}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete', 'copy']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_PARAMETER_ENERGIESTEUER)}
                    showColumnsHelp={true}
                />
            </div>
        );
    }
}
